/**
 * Resolves the poster frame for a video Media doc.
 *
 * Prefers the populated `videoThumbnail` relation (always current, even if the
 * poster file was later renamed) and falls back to the denormalised
 * `videoThumbnailUrl`, which survives queries that don't reach deep enough to
 * populate the relation. `poster` is accepted as a legacy escape hatch for
 * blocks that already passed one in by hand.
 */
type PosterCarrier = {
  poster?: unknown
  videoThumbnail?: unknown
  videoThumbnailUrl?: unknown
}

export const getVideoPosterUrl = (resource: unknown, baseUrl: string = ''): string | undefined => {
  if (!resource || typeof resource !== 'object') return undefined

  const { poster, videoThumbnail, videoThumbnailUrl } = resource as PosterCarrier

  const fromRelation =
    videoThumbnail && typeof videoThumbnail === 'object'
      ? (videoThumbnail as { url?: unknown }).url
      : undefined

  const raw =
    (typeof fromRelation === 'string' && fromRelation) ||
    (typeof videoThumbnailUrl === 'string' && videoThumbnailUrl) ||
    (typeof poster === 'string' && poster) ||
    undefined

  if (!raw) return undefined
  if (/^(https?:)?\/\//.test(raw) || raw.startsWith('data:')) return raw

  return `${baseUrl}${raw}`
}
